// FinalCTA.jsx - Decision Moment
import React from 'react';
import './FinalCTA.css';

const FinalCTA = () => {
  const handleStartCreating = () => {
    window.location.href = 'https://account.fluxuro.ai';
  };

  return (
    <section className="landing-section final-cta-section">
      <h2 className="final-cta-title">Ready to create?</h2>
      <p className="final-cta-subtitle">
        Start in Zen and generate your first result in minutes.
      </p>

      <div className="final-cta-buttons">
        <button className="btn-primary" onClick={handleStartCreating}>
          Start Creating
        </button>
        <button 
          className="btn-secondary"
          onClick={handleStartCreating}
        >
          Sign in
        </button>
      </div>
    </section>
  );
};

export default FinalCTA;
